import { render, staticRenderFns } from "./ProspectCloture.vue?vue&type=template&id=6bcc0fc9"
import script from "./ProspectCloture.vue?vue&type=script&lang=ts"
export * from "./ProspectCloture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports